export default __webpack_public_path__ + "img/24.asset.c53a5182.jpeg";